export const pageSizeConstants = {
    SET_PAGESIZE: 'SET_PAGESIZE',
};
